import React from 'react'
import "../styles/join-us.css"
import { useEffect } from 'react';
import { useRef } from 'react';

const GoalsSection = () => {

  const servicesRef = useRef(null);
  
   useEffect (() => {
    const revealElements = servicesRef.current.querySelectorAll("[data-reveal]");
     const scrollReveal = () => {
        for (let i = 0; i < revealElements.length; i++) {
         const elementIsInScreen =
        revealElements[i].getBoundingClientRect().top < window.innerHeight / 1.15;
      
      if (elementIsInScreen) {
       revealElements[i].classList.add("revealed");
       } else {
          revealElements[i].classList.remove("revealed");
           }
        }
       };
      
       window.addEventListener("scroll", scrollReveal);
          scrollReveal(); // Initial check
      
          return () => {
            window.removeEventListener("scroll", scrollReveal);
          };
        }, []);

  return (
    <>
    {/* Services 2 Section */}
<section id="services-2" className="services-2 section light-background" ref={servicesRef}>
  {/* Section Title */}
  <div className="container section-title" data-aos="fade-up">
    <h2 data-reveal>Goals</h2>
    <p data-reveal>STRATEGIC GOALS AND ASSOCIATED IMPACT</p>
  </div>
  {/* End Section Title */}

  <section className="full-cards-section section">
    <div className="container full-cards">
      <div className="row gy-4">
        {/* Card 1 */}
        <div className="col-12" data-aos="fade-up" data-aos-delay="100">
          <div className="full-card d-flex position-relative">
            <i className="bi bi-briefcase icon flex-shrink-0" data-reveal="left"></i>
            <div className="card-content">
              <h4 className="title" data-reveal>
                1. Provide access to digital tools and safe learning spaces
              </h4>
              <div className="card-grid">
                <div className="action-plan" data-reveal>
                  <h5  >Action Plan:</h5>
                  <ul>
                    <li>
                    Establish mobile ICT Resource and learning hubs equipped with tools for digital
                    literacy, e-commerce training, and vocational skills development.
                    </li>
                    <li>
                   Partner with local schools and institutions to host workshops and training
                  sessions.
                    </li>
                  
                  </ul>
                </div>
                <div className="impact" data-reveal>
                  <h5>Impact:</h5>
                  <ul>
                    <li>
                      Removes logistical and financial barriers to education and training.
                    </li>
                    <li>
                    Builds a supportive environment for academic acquisition and practical
                    application.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Card 2 */}
        <div className="col-12" data-aos="fade-up" data-aos-delay="200">
          <div className="full-card d-flex position-relative">
            <i className="bi bi-card-checklist icon flex-shrink-0" data-reveal="left"></i>
            <div className="card-content">
              <h4 className="title" data-reveal>
                2. Tailored Education and Skill-Building Programs
              </h4>
              <div className="card-grid">
                <div className="action-plan" data-reveal>
                  <h5  >Action Plan:</h5>
                  <ul>
                    <li>
                      Develop flexible, modular programs in ICT, e-commerce, entrepreneurship, and
                      financial literacy.
                    </li>
                    <li>
                      Provide mentorship and goal-setting workshops tailored to individual needs.
                    </li>
                 
                  </ul>
                </div>
                <div className="impact" data-reveal>
                  <h5 >Impact:</h5>
                  <ul>
                    <li>
                    Builds confidence and opens pathways to formal education or business
                  opportunities.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Card 3 */}
        <div className="col-12" data-aos="fade-up" data-aos-delay="300">
          <div className="full-card d-flex position-relative">
            <i className="bi bi-bar-chart icon flex-shrink-0" data-reveal></i>
            <div className="card-content">
              <h4 className="title" data-reveal>
                3. Community-Led and Peer Mentorship Model
              </h4>
              <div className="card-grid">
                <div className="action-plan" data-reveal>
                  <h5>Action Plan:</h5>
                  <ul>
                   
                    <li>
                    Foster peer-to-peer learning through group projects and networking
                    opportunities.
                    </li>
                    <li>
                    Work with partners and stakeholders to offer mentorship and subsequent
                    support.
                    </li>
                  </ul>
                </div>
                <div className="impact" data-reveal>
                  <h5>Impact:</h5>
                  <ul>
                    <li>
                     Builds a strong support system rooted in local communities.
                    </li>
                    <li>
                     Ensures long-term engagement and scalability.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Card 4 */}
        <div className="col-12" data-aos="fade-up" data-aos-delay="400">
          <div className="full-card d-flex position-relative">
            <i className="bi bi-binoculars icon flex-shrink-0" data-reveal="left"></i>
            <div className="card-content">
              <h4 className="title" data-reveal>
                4. Leverage Partnerships for Resources and Opportunities
              </h4>
              <div className="card-grid">
                <div className="action-plan" data-reveal>
                  <h5>Action Plan:</h5>
                  <ul>
                    <li>
                      Partner with NGOs, government agencies, and private organizations to support
                      efficient delivery of the model.
                    </li>
                    <li>
                     Collaborate with tech companies for ICT and e-commerce platforms.
                    </li>
                    <li>
                     Secure required scholarships and sponsorships from partner institutions.
                    </li>
                  </ul>
                </div>
                <div className="impact" data-reveal>
                  <h5>Impact:</h5>
                  <ul>
                    <li>
                     Provides participants with access to high-quality training and resources.
                    </li>
                    <li>
                     Expands reach and create avenues for scaling the initiative.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Card 5 */}
        <div className="col-12" data-aos="fade-up" data-aos-delay="500">
          <div className="full-card d-flex position-relative">
            <i className="bi bi-calendar4-week icon flex-shrink-0" data-reveal="left"></i>
            <div className="card-content">
              <h4 className="title" data-reveal>
                5. Focus on Sustainability and Monitoring
              </h4>
              <div className="card-grid">
                <div className="action-plan" data-reveal>
                  <h5>Action Plan:</h5>
                  <ul>
                    <li>
                      Structure partner scholarships and sponsorships to underwrite Resource Hub
                      operations and enable local delivery of accredited learning.
                    </li>
                    <li>
                    Develop a robust monitoring and evaluation framework to measure impact and
                    improve programs.
                    </li>
                    <li>
                     Establish an Endowment Fund
                    </li>
                   </ul>
                </div>
                <div className="impact" data-reveal>
                  <h5>Impact:</h5>
                  <ul>
                    <li>
                      Ensures financial and operational sustainability.
                    </li>
                    <li>
                      Demonstrates accountability and builds trust among
                      stakeholders.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Card 6 */}
        <div className="col-12" data-aos="fade-up" data-aos-delay="550">
          <div className="full-card d-flex position-relative">
            <i className="bi bi-brightness-high icon flex-shrink-0" data-reveal="left"></i>
            <div className="card-content">
              <h4 className="title" data-reveal>
                6. Advocacy and Awareness Campaigns
              </h4>
              <div className="card-grid">
                <div className="action-plan" data-reveal>
                  <h5>Action Plan:</h5>
                  <ul>
              
                    <li>
                      Launch campaigns to shift narratives around &quot;fair
                      academic performers&quot; and their potential.
                    </li>
                  </ul>
                </div>
                <div className="impact" data-reveal>
                  <h5>Impact:</h5>
                  <ul>
                    <li>
                      Raises awareness and garners support for the target
                      demographic.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Card 7 */}
        <div className="col-12" data-aos="fade-up" data-aos-delay="600">
          <div className="full-card d-flex position-relative">
            <i className="bi bi-calendar4-week icon flex-shrink-0" data-reveal="left"></i>
            <div className="card-content">
              <h4 className="title" data-reveal>
                7. Expand Reach with Digital Platforms
              </h4>
              <div className="card-grid">
                <div className="action-plan" data-reveal>
                  <h5>Action Plan:</h5>
                  <ul>
                    <li>
                      Develop online learning platforms accessible through
                      mobile devices.
                    </li>
                    <li>
                     Use social media and digital platforms to launch products and services that within
                    12-18 months convert into income.
                    </li>
 
                  </ul>
                </div>
                <div className="impact" data-reveal>
                  <h5>Impact:</h5>
                  <ul>
                    
                    <li>
                      Launch and implement projects that convert into income within 12-18 months.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</section>
{/* /Services 2 Section */}

    </>
  )
}

export default GoalsSection